import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Home from '../../pages/home/component';
import About from "../../pages/about/component";
import Contact from "../../pages/contact/component";
import Campaign from "../../pages/campaign/component";
import { slide as Menu } from 'react-burger-menu';
import Styles from './style.css';
import * as Icon from "react-feather";
import HamburgerMenu from 'react-hamburger-menu';
import NoMatch from "../../pages/no-match/component";
import Lab from "../../pages/lab/component";
import Partners from "../../pages/partners/component";

var styles = {
    bmMenu: {
        background: '#000000',
        padding: '2.4em 1em 0',
        boxSizing: 'border-box',
        overflowY: 'hidden',
    },
    bmMorphShape: {
        fill: '#000000'
    },
    bmItemList: {
        color: '#b8b7ad',
        padding: '0.8em',
        display: 'flex',
        flexDirection: 'column'
    },
    bmItem: {
        display: 'inline-block',
        cursor: 'pointer',
        fontFamily: 'Geometria-Bold',
        height: '70px',
        fontSize: "35px",
        color: "white"
    },
    bmOverlay: {
        background: 'rgba(0, 0, 0, 0.3)',
        zIndex: '900'
    },
};

class Main extends React.Component {

    constructor (props) {
        super(props)
        this.state = {
            open: false
        }
    }

    handleStateChange (state) {
        this.setState({open: state.isOpen}, () => {
            if(this.state.open){
                document.body.style.position = "fixed";
                document.body.style.left = "0";
                document.body.style.right = "0";
                document.body.style.overflowX = "hidden";
            }else{
                document.body.style.position = "inherit";
                document.body.style.left = "inherit";
                document.body.style.right = "inherit";
                document.body.style.overflowX = "inherit";
            }
        })
    }

    toggleMenu () {
        this.setState({open: !this.state.open})
    }

    goTo(option){
        window.location.href = option;
    }

    _goInternal(option){
        window.open(option, '_self');
    }

    render () {
        return (
            <div id="outer-container">
                <Menu onStateChange={(state) => this.handleStateChange(state)} width={'270px'} styles={ styles } isOpen={this.state.open} pageWrapId={ "page-wrap" } outerContainerId={ "outer-container" } >
                    <a onClick={() => this.goTo('/')}>Welcome</a>
                    <a onClick={() => this.goTo('/lab')}>Lab</a>
                    <a onClick={() => this.goTo('/partners')}>Partners</a>
                    <a onClick={() => this.goTo('/about')}>About</a>
                    <a onClick={() => this.goTo('/contact')}>Contact</a>
                    <div className={Styles.menuBottom}>
                        <div className={Styles.menuBottomTitle}>
                            Let's make it happen
                        </div>
                        <div className={Styles.menuBottomIcons}>
                            <div onClick={() => this._goInternal("mailto:swedishtechmafia@icloud.com?Subject=Hello")}  className={Styles.menuBottomIconsItem}>
                                <div className={Styles.menuBottomIconsItemEmail}>@</div>
                            </div>
                            <div onClick={() => this._goInternal("whatsapp://send?text=Hey Swedish Tech Mafia...&phone=+971543429986")} className={Styles.menuBottomIconsItem}>
                                <img className={Styles.menuBottomIconsItemWhatsApp} src={require("../../assets/images/STM_social_whatsapp.png")}/>
                            </div>
                        </div>
                    </div>
                </Menu>
                <div className={Styles.menuIcon} onClick={() => this.toggleMenu()}>
                    <HamburgerMenu
                        isOpen={this.state.open}
                        menuClicked={this.toggleMenu.bind(this)}
                        width={30}
                        height={18}
                        strokeWidth={3}
                        rotate={0}
                        color='white'
                        borderRadius={1}
                        animationDuration={0.5}
                    />
                </div>
                <main id="page-wrap">
                    <BrowserRouter>
                        <Switch>

                            /*PUBLIC*/
                            <Route exact path='/' component={Home}/>
                            <Route exact path='/lab' component={Lab}/>
                            <Route exact path='/partners' component={Partners}/>
                            <Route exact path='/about' component={About}/>
                            <Route exact path='/contact' component={Contact}/>
                            <Route exact path='/campaign' component={Campaign}/>
                            <Route component={NoMatch} />

                        </Switch>
                    </BrowserRouter>
                </main>
            </div>
        )
    }

}

export default Main


// WEBPACK FOOTER //
// ./src/components/main/component.js